<template>
    <v-row row wrap>
        <v-col cols="12">
            <v-card-actions class="d-inline text-left">
                <v-dialog class="text-left" v-model="dialog" persistent max-width="640px">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn depressed color="secondary" v-bind="attrs" v-on="on">
                            <v-icon left>mdi-basket-plus</v-icon>
                            {{ buttonLabel }}
                        </v-btn>
                    </template>
                    <v-card class="product-search-dialog">
                        <v-card-title class="product-dialog-title">
                            <v-icon left color="secondary">mdi-magnify</v-icon>
                            Buscar producto
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text class="product-dialog-card-text">
                            <v-container class="pa-4">
                                <v-form ref="form" autocomplete="off" @submit.prevent="agregarProducto">
                                    <!-- Sección: Código de barras -->
                                    <div class="search-section barcode-section">
                                        <div class="section-header">
                                            <v-icon small class="mr-1">mdi-barcode-scan</v-icon>
                                            <span class="section-title">Código de barras</span>
                                        </div>
                                        <v-row align="center" no-gutters>
                                            <v-col cols="12" sm="8" class="pr-sm-2">
                                                <v-text-field
                                                    ref="productoTextField"
                                                    name="codigo del producto"
                                                    v-model="form.idProducto"
                                                    :label="$t('movimiento.labels.idProducto')"
                                                    :placeholder="$t('movimiento.labels.idProducto')"
                                                    color="secondary"
                                                    outlined
                                                    dense
                                                    hide-details="auto"
                                                    autofocus
                                                    prepend-icon="mdi-barcode"
                                                    @blur="trimCodigoBarrasField"
                                                    @keyup.enter="findByParamsProducto(form.idProducto)"
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="4" class="pt-2 pt-sm-0">
                                                <v-btn
                                                    block
                                                    color="primary"
                                                    :loading="loading"
                                                    depressed
                                                    @click="findByParamsProducto(form.idProducto)"
                                                >
                                                    <v-icon left small>mdi-plus</v-icon>
                                                    Agregar
                                                </v-btn>
                                            </v-col>
                                        </v-row>
                                    </div>

                                    <v-divider class="my-4">
                                        <span class="divider-text">o</span>
                                    </v-divider>

                                    <!-- Sección: Búsqueda por texto -->
                                    <div class="search-section autocomplete-section">
                                        <div class="section-header">
                                            <v-icon small class="mr-1">mdi-text-search</v-icon>
                                            <span class="section-title">Buscar por marca o modelo</span>
                                        </div>
                                        <v-row align="center" no-gutters>
                                            <v-col cols="12" sm="8" class="pr-sm-2">
                                                <v-autocomplete
                                                    ref="productoAutocomplete"
                                                    v-model="selectedProducto"
                                                    :items="autocompleteItems"
                                                    :loading="searchLoading"
                                                    :search-input.sync="searchText"
                                                    item-text="displayText"
                                                    item-value="id"
                                                    return-object
                                                    label="Escriba para buscar..."
                                                    placeholder="Ej: Nike, Adidas, modelo..."
                                                    color="secondary"
                                                    outlined
                                                    dense
                                                    hide-details="auto"
                                                    clearable
                                                    no-filter
                                                    prepend-icon="mdi-magnify"
                                                    :menu-props="{ contentClass: 'devolucion-autocomplete-menu' }"
                                                    @change="onProductoSelected"
                                                    @input="onAutocompleteInput"
                                                >
                                                    <template v-slot:item="{ item }">
                                                        <v-list-item-content class="pa-0">
                                                            <div class="autocomplete-item-wrapper">
                                                                <div class="autocomplete-left d-flex flex-column">
                                                                    <span class="font-weight-medium text-truncate">
                                                                        {{ item.nombre || `${item.marca.nombre} ${item.modelo.nombre}` }}
                                                                    </span>
                                                                    <span class="grey--text text--darken-1 text-caption">
                                                                        {{ item.marca.nombre }} {{ item.modelo.nombre }}
                                                                        <span v-if="item.tamanio && item.tamanio.tamanio">
                                                                            - {{ item.tamanio.tamanio }}
                                                                        </span>
                                                                    </span>
                                                                </div>
                                                                <span class="autocomplete-stock">Stock: {{ item.stock }}</span>
                                                            </div>
                                                        </v-list-item-content>
                                                    </template>
                                                    <template v-slot:selection="{ item }">
                                                        <span class="text-truncate">
                                                            {{ item.nombre || `${item.marca.nombre} ${item.modelo.nombre}` }}
                                                        </span>
                                                    </template>
                                                </v-autocomplete>
                                            </v-col>
                                            <v-col cols="12" sm="4" class="pt-2 pt-sm-0">
                                                <v-btn
                                                    block
                                                    color="primary"
                                                    depressed
                                                    :disabled="!item.id || (tipo === 'nuevos' && stockDisponibleEnCard === 0)"
                                                    @click="agregarProducto"
                                                >
                                                    <v-icon left small>mdi-plus</v-icon>
                                                    Agregar
                                                </v-btn>
                                            </v-col>
                                        </v-row>
                                    </div>

                                    <!-- Error: producto no encontrado por código de barras -->
                                    <v-row v-if="searchError && !item.id">
                                        <v-col cols="12">
                                            <v-alert type="error" dense outlined class="search-result-alert">
                                                <v-icon left>mdi-barcode-off</v-icon>
                                                No se encontró ningún producto con ese código de barras
                                            </v-alert>
                                        </v-col>
                                    </v-row>

                                    <!-- Resultado: tarjeta del producto encontrado -->
                                    <v-row v-if="item.id" class="product-result-row mt-6">
                                        <!-- Sin stock (solo para tipo nuevos) -->
                                        <v-col cols="12" v-if="item.stock === 0 && tipo === 'nuevos'">
                                            <v-card outlined class="product-result-card product-result-error">
                                                <v-card-text class="pa-4">
                                                    <div class="d-flex align-center">
                                                        <v-avatar size="48" color="error" class="mr-4 flex-shrink-0">
                                                            <v-icon color="white">mdi-alert-circle-outline</v-icon>
                                                        </v-avatar>
                                                        <div class="flex-grow-1 min-width-0">
                                                            <div class="product-result-title error--text mb-1">Producto sin stock</div>
                                                            <div v-if="item.nombre" class="product-result-nombre text-body-1 font-weight-medium mb-1">{{ item.nombre }}</div>
                                                            <div class="product-result-info">
                                                                <span class="product-result-marca">{{ item.marca.nombre }}</span>
                                                                <span class="product-result-modelo">{{ item.modelo.nombre }}</span>
                                                                <span class="product-result-tamanio">{{ (item.tamanio && item.tamanio.tamanio) ? item.tamanio.tamanio : '-' }}</span>
                                                            </div>
                                                            <div class="product-result-stock text--disabled">Stock: 0</div>
                                                            <div class="text-caption grey--text mt-1">No hay stock disponible para este producto</div>
                                                        </div>
                                                    </div>
                                                </v-card-text>
                                            </v-card>
                                        </v-col>

                                        <!-- Producto encontrado (con stock o tipo devueltos) -->
                                        <v-col cols="12" v-else>
                                            <v-card outlined class="product-result-card product-result-success">
                                                <v-card-text class="pa-4">
                                                    <div class="d-flex align-center">
                                                        <v-avatar size="48" color="success" class="mr-4 flex-shrink-0">
                                                            <v-icon color="white">mdi-check-circle-outline</v-icon>
                                                        </v-avatar>
                                                        <div class="flex-grow-1 min-width-0">
                                                            <div class="product-result-title success--text mb-1">Producto encontrado</div>
                                                            <div v-if="item.nombre" class="product-result-nombre text-body-1 font-weight-medium mb-1">{{ item.nombre }}</div>
                                                            <div class="product-result-info">
                                                                <span class="product-result-marca">{{ item.marca.nombre }}</span>
                                                                <span class="product-result-modelo">{{ item.modelo.nombre }}</span>
                                                                <span class="product-result-tamanio">{{ (item.tamanio && item.tamanio.tamanio) ? item.tamanio.tamanio : '-' }}</span>
                                                            </div>
                                                            <div class="product-result-stock success--text">Stock: {{ stockDisponibleEnCard }}</div>
                                                        </div>
                                                        <v-btn
                                                            v-if="tipo === 'devueltos' || stockDisponibleEnCard > 0"
                                                            small
                                                            color="primary"
                                                            depressed
                                                            class="ml-3 flex-shrink-0"
                                                            @click="agregarOtroProducto"
                                                        >
                                                            <v-icon left small>mdi-plus</v-icon>
                                                            Agregar otro
                                                        </v-btn>
                                                    </div>
                                                </v-card-text>
                                            </v-card>
                                        </v-col>
                                    </v-row>
                                </v-form>
                            </v-container>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions class="product-dialog-actions px-4 py-3">
                            <v-spacer></v-spacer>
                            <v-btn color="grey darken-1" text @click="closeDialog(); resetForm()">
                                <v-icon left small>mdi-close</v-icon>
                                Cerrar
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-card-actions>

            <div class="table-fixed-header-wrap">
            <v-data-table
                class="mt-4 product-list-table"
                fixed-header
                height="180px"
                :headers="headers"
                :items="items"
                :loading="loading"
                hide-default-footer
                :items-per-page="-1"
            >
                <template v-slot:item.nombre="{ item }">
                    <div class="d-flex flex-column">
                        <span class="font-weight-medium">{{ item.nombre || `${item.marca} ${item.modelo}` }}</span>
                        <span v-if="item.nombre" class="grey--text text--darken-1 text-caption">
                            {{ item.marca }} {{ item.modelo }}<span v-if="item.tamanio && item.tamanio !== '-'"> - {{ item.tamanio }}</span>
                        </span>
                    </div>
                </template>

                <template v-slot:item.precio="{ item }">
                    <div v-if="item.ofertaAplicada && item.precioBase">
                        <div class="text-decoration-line-through grey--text text-caption">
                            ${{ item.precioBase.toFixed(2) }}
                        </div>
                        <div class="success--text font-weight-bold">
                            ${{ item.precio.toFixed(2) }}
                        </div>
                    </div>
                    <div v-else>
                        ${{ item.precio.toFixed(2) }}
                    </div>
                </template>

                <template v-slot:item.stock="{ item }">
                    <span class="text-center d-block">{{ item.stock != null ? item.stock : 0 }}</span>
                </template>

                <template v-slot:item.oferta="{ item }">
                    <v-tooltip bottom v-if="item.ofertaAplicada">
                        <template v-slot:activator="{ on, attrs }">
                            <v-chip
                                color="success"
                                text-color="white"
                                small
                                v-bind="attrs"
                                v-on="on"
                                class="oferta-chip"
                            >
                                <v-icon left small>mdi-sale</v-icon>
                                {{ getOfertaDescripcion(item.ofertaAplicada) }}
                            </v-chip>
                        </template>
                        <span>
                            <strong>{{ item.ofertaAplicada.nombre }}</strong><br>
                            Ahorro: ${{ item.ofertaAplicada.descuento.toFixed(2) }}
                        </span>
                    </v-tooltip>
                    <span v-else class="grey--text text-caption">-</span>
                </template>

                <template slot="no-data">
                    <div class="text-xs-center" v-t="'common.noData'"></div>
                </template>

                <template slot="loading">
                    <div class="text-xs-center" v-t="'common.loading'"></div>
                </template>

                <template v-slot:item.action="{ item }">
                    <delete-button @click="$emit('delete', item)" />
                </template>
            </v-data-table>
            </div>
        </v-col>
    </v-row>
</template>

<script>
import { DeleteButton } from "@dracul/common-frontend"
import ProductoProvider from "../../../../producto/providers/ProductoProvider";
import UserConfigurationProvider from "../../../../user-configuration/providers/UserConfigurationProvider";

export default {
    name: "DevolucionList",
    components: { DeleteButton },
    props: {
        items: { type: Array, default: () => [] },
        tipo: { type: String, default: 'devueltos' }, // 'devueltos' o 'nuevos'
        value: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            loading: false,
            dialog: false,
            item: {},
            searchError: false,
            searchText: '',
            selectedProducto: null,
            autocompleteItems: [],
            searchLoading: false,
            searchTimeout: null,
            lastSearchText: '',
            isProtectingText: false,
            cantidadAgregadaItem: 0,
        }
    },
    computed: {
        stockDisponibleEnCard() {
            if (!this.item || !this.item.id) return 0;
            const stock = this.item.stock || 0;
            return Math.max(0, stock - this.cantidadAgregadaItem);
        },
        form: {
            get() { return this.value },
            set(val) { this.$emit('input', val) }
        },
        headers() {
            const h = [
                { text: this.$t('producto.labels.nombre') || 'Nombre', value: 'nombre' },
                { text: this.$t('movimiento.labels.precio'), value: 'precio' },
                { text: this.$t('movimiento.labels.cantidad'), value: 'cantidad', align: 'center' },
            ];
            if (this.tipo === 'nuevos') {
                h.push({ text: 'Stock real', value: 'stock', align: 'center', sortable: false });
            }
            h.push({ text: 'Oferta', value: 'oferta', sortable: false });
            h.push({ text: this.$t('common.actions'), value: 'action', sortable: false });
            return h;
        },
        buttonLabel() {
            return this.tipo === 'devueltos' 
                ? this.$t('producto.labels.ingresar')
                : this.$t('producto.labels.ingresar')
        }
    },
    watch: {
        searchText: {
            handler(newVal) {
                if (this.isProtectingText) return;
                if (this.lastSearchText && this.item && this.item.id && (!newVal || newVal === '')) {
                    this.isProtectingText = true;
                    this.$nextTick(() => {
                        this.searchText = this.lastSearchText;
                        this.isProtectingText = false;
                    });
                    return;
                }
                if (newVal && newVal.trim().length > 0) {
                    this.lastSearchText = newVal;
                }
                if (this.searchTimeout) clearTimeout(this.searchTimeout);
                if (newVal && newVal.trim().length >= 2) {
                    this.searchTimeout = setTimeout(() => this.searchProductos(), 500);
                } else if (!newVal || newVal === '') {
                    if (!this.item || !this.item.id) {
                        this.autocompleteItems = [];
                        this.lastSearchText = '';
                    }
                }
            },
            immediate: false
        },
        dialog(newVal) {
            if (newVal) {
                this.$nextTick(() => {
                    if (this.$refs.productoTextField) {
                        this.$refs.productoTextField.focus();
                    }
                });
            }
        }
    },
    methods: {
        searchProductos() {
            if (!this.searchText || this.searchText.trim().length < 2) {
                this.autocompleteItems = [];
                return;
            }

            this.searchLoading = true;
            const depositoId = UserConfigurationProvider.getDepositoIdFromCache();
            ProductoProvider.searchProductosByMarcaModelo(this.searchText.trim(), depositoId)
                .then(r => {
                    const productos = r.data && r.data.productoSearchByMarcaModelo
                        ? r.data.productoSearchByMarcaModelo
                        : [];
                    
                    this.autocompleteItems = productos.map(producto => ({
                        ...producto,
                        displayText: producto.nombre
                            ? producto.nombre
                            : `${producto.marca?.nombre || ''} ${producto.modelo?.nombre || ''}`.trim()
                    }));
                })
                .catch(err => {
                    console.error(err);
                    this.autocompleteItems = [];
                })
                .finally(() => {
                    this.searchLoading = false;
                });
        },
        onProductoSelected(producto) {
            if (producto) {
                this.cantidadAgregadaItem = 0;
                this.item = producto;
                this.searchError = false;
                const textoActual = this.searchText || `${producto.marca.nombre} ${producto.modelo.nombre}`;
                this.lastSearchText = textoActual;
                // Agregar el producto automáticamente al seleccionar (igual que en ventas)
                this.agregarProducto();
                this.$nextTick(() => {
                    this.selectedProducto = null;
                    this.searchText = textoActual;
                });
                setTimeout(() => {
                    if (this.lastSearchText && !this.searchText) {
                        this.searchText = this.lastSearchText;
                    }
                }, 100);
            }
        },
        onAutocompleteInput(value) {
            if (!value && !this.isProtectingText) {
                this.selectedProducto = null;
                this.item = {};
                this.lastSearchText = '';
            } else if (value) {
                this.lastSearchText = value;
            }
        },
        agregarOtroProducto() {
            if (!this.item || !this.item.id) return;
            if (this.tipo === 'nuevos' && this.stockDisponibleEnCard <= 0) return;
            this.$emit('addProductToCart', { producto: this.item, cantidad: 1 });
            this.cantidadAgregadaItem += 1;
        },
        trimCodigoBarrasField() {
            if (this.form.idProducto == null || this.form.idProducto === '') return
            const t = String(this.form.idProducto).trim()
            this.form.idProducto = t === '' ? null : t
        },
        findByParamsProducto(codigoBarras) {
            const codigo = codigoBarras != null && codigoBarras !== ''
                ? String(codigoBarras).trim()
                : ''
            this.form.idProducto = codigo === '' ? null : codigo
            if (!codigo) {
                this.searchError = false
                return
            }
            this.loading = true;
            this.searchError = false;
            const depositoId = UserConfigurationProvider.getDepositoIdFromCache();
            ProductoProvider.findByParamsProducto(codigo, depositoId)
                .then(r => {
                    const encontrados = r.data?.productoFindByParams || [];
                    if (encontrados.length > 0) {
                        this.cantidadAgregadaItem = 0;
                        this.item = encontrados[0];
                        this.agregarProducto();
                        this.$nextTick(() => {
                            this.form.idProducto = null;
                            if (this.$refs.productoTextField) {
                                this.$refs.productoTextField.focus();
                            }
                        });
                    } else {
                        this.item = {};
                        this.searchError = true;
                    }
                })
                .catch(err => {
                    console.error(err);
                    this.searchError = true;
                })
                .finally(() => { this.loading = false });
        },
        agregarProducto() {
            if (!this.item || !this.item.id) return;
            if (this.tipo === 'nuevos' && this.stockDisponibleEnCard <= 0) return;

            this.$emit('addProductToCart', { producto: this.item, cantidad: 1 });
            this.cantidadAgregadaItem += 1;
            this.searchError = false;

            this.$nextTick(() => {
                if (this.lastSearchText) {
                    this.searchText = this.lastSearchText;
                    this.selectedProducto = null;
                }
            });
            setTimeout(() => {
                if (this.lastSearchText && (!this.searchText || this.searchText === '')) {
                    this.searchText = this.lastSearchText;
                }
            }, 50);
        },
        resetForm() {
            this.form.idProducto = null;
            this.item = {};
            this.searchError = false;
            this.searchText = '';
            this.selectedProducto = null;
            this.autocompleteItems = [];
            this.lastSearchText = '';
            this.cantidadAgregadaItem = 0;
        },
        closeDialog() {
            this.dialog = false;
            this.$emit('closeDialog');
        },
        getOfertaDescripcion(oferta) {
            if (!oferta) return '';
            if (oferta.tipo === 'porcentaje') {
                return `${oferta.valor}% OFF`;
            } else if (oferta.tipo === 'por_cantidad') {
                return oferta.valor != null
                    ? `${oferta.valor}% OFF`
                    : 'Por cantidad';
            } else if (oferta.tipo === '2x1') {
                return '2x1';
            } else if (oferta.tipo === '3x2') {
                return '3x2';
            } else if (oferta.tipo === '4x3') {
                return '4x3';
            }
            return oferta.tipo;
        }
    }
}
</script>

<style scoped>
.table-fixed-header-wrap {
    min-height: 0;
}
.product-search-dialog {
    border-radius: 12px;
    overflow: hidden;
}

.product-dialog-title {
    font-weight: 600;
    letter-spacing: 0.5px;
}

.product-dialog-card-text {
    padding-bottom: 8px !important;
    max-height: 70vh;
    overflow-y: auto;
}

.product-dialog-actions {
    padding-top: 8px !important;
}

.search-section {
    padding: 4px 0;
}

.section-header {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    color: rgba(0, 0, 0, 0.7);
}

.section-title {
    font-size: 0.9rem;
    font-weight: 600;
}

.divider-text {
    padding: 0 12px;
    font-size: 0.75rem;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.4);
    text-transform: uppercase;
    letter-spacing: 0.5px;
    background: white;
}

.product-result-row {
    padding-top: 8px;
}

.search-result-alert {
    border-radius: 8px;
}

.product-result-card {
    border-radius: 10px;
    transition: box-shadow 0.2s ease;
}

.product-result-card:hover {
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

.product-result-error {
    border-left: 4px solid #f44336;
}

.product-result-success {
    border-left: 4px solid #4caf50;
}

.product-result-title {
    font-size: 1rem;
    font-weight: 700;
}

.product-result-info {
    display: flex;
    align-items: baseline;
    flex-wrap: wrap;
    gap: 4px 8px;
}

.product-result-marca {
    font-size: 1.1rem;
    font-weight: 600;
}

.product-result-sep {
    color: rgba(0, 0, 0, 0.4);
    font-size: 1rem;
}

.product-result-modelo {
    font-size: 1.1rem;
    font-weight: 600;
}

.product-result-tamanio {
    font-size: 1rem;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.75);
}

.product-result-stock {
    font-size: 1.05rem;
    font-weight: 600;
    margin-top: 2px;
}

.product-list-table {
    border-radius: 8px;
    overflow: hidden;
}

.oferta-chip {
    animation: pulse 2s ease-in-out infinite;
    font-weight: 600;
}

@keyframes pulse {
    0%, 100% { transform: scale(1); }
    50% { transform: scale(1.05); }
}
</style>

<style lang="scss">
/* Estilos para el menú del autocomplete (se renderiza en portal) */
.devolucion-autocomplete-menu {
    .v-list-item {
        min-height: 48px !important;
        align-items: center !important;
    }
    .v-list-item__content {
        flex: 1 1 auto !important;
        min-width: 0 !important;
        padding: 0 16px !important;
        align-items: center !important;
        overflow: visible !important;
        display: flex !important;
        flex-direction: row !important;
    }
    .v-list-item:first-child .v-list-item__content,
    .v-list-item.v-list-item--highlighted .v-list-item__content {
        flex-direction: row !important;
    }
    .autocomplete-item-wrapper {
        display: flex !important;
        flex-direction: row !important;
        flex-wrap: nowrap !important;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
        padding: 14px 0;
        min-height: 48px;
        font-size: 1rem !important;
        width: 100%;
    }
    .autocomplete-left {
        display: flex !important;
        align-items: baseline;
        flex-wrap: nowrap !important;
        gap: 4px 8px;
        min-width: 0;
        overflow: hidden;
    }
    .autocomplete-marca { font-weight: 600; }
    .autocomplete-sep { color: rgba(0, 0, 0, 0.4); }
    .autocomplete-modelo { font-weight: 600; }
    .autocomplete-tamanio { font-weight: 500; color: rgba(0, 0, 0, 0.75); }
    .autocomplete-stock {
        font-weight: 600;
        color: rgba(0, 0, 0, 0.8);
        flex-shrink: 0 !important;
        white-space: nowrap;
    }
}
</style>
